module.exports = __webpack_public_path__ + "assets/img/driver-btn-5a4a38ae.png";